<template>
  <div>
    <div class="text-center sm:flex sm:gap-2 sm:items-center sm:justify-center">
      <div class="sm:hidden">
        <span class="marker marker-desktop"
          >{{ currentRelogio }}º DIA ÚTIL</span
        >
      </div>

      <div class="flex sm:flex-row items-center justify-center">
        <div class="hidden sm:flex gap-2 items-center">
          <span class="marker marker-responsive sm:marker-desktop"
            >{{ currentRelogio }}º DIA ÚTIL</span
          >
        </div>

        <div class="divider hidden md:block"></div>

        <div class="flex gap-1 sm:gap-2 items-center">
          <span class="w-3 h-3 rounded-full main-primary"></span>
          <span class="marker marker-responsive sm:marker-desktop"
            >RELÓGIO {{ totalRelogio }}</span
          >
        </div>

        <div class="divider"></div>

        <div class="flex gap-1 sm:gap-2 items-center">
          <span
            class="w-3 h-3 rounded-full"
            :style="{ backgroundColor: performanceActualSales }"
          ></span>
          <span class="marker marker-responsive sm:marker-desktop"
            >ATUAL {{ totalVendas }}</span
          >
        </div>

        <div class="divider"></div>

        <div class="flex gap-1 sm:gap-2 items-center">
          <span class="marker marker-responsive sm:marker-desktop"
            >META MENSAL {{ metaTotal }}</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LegendasHeader',
  data() {
    return {};
  },
  props: {
    metaTotal: {
      type: Number,
      default: 0,
    },
    totalVendas: {
      type: Number,
      default: 0,
    },
    currentRelogio: {
      type: Number,
      default: 1,
    },
    totalRelogio: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    performanceActualSales() {
      const PERFORMANCE_VALUE = Math.floor(this.totalRelogio * 0.9);

      if (this.totalVendas >= this.totalRelogio) {
        return '#5ADC96';
      }

      if (this.totalVendas < PERFORMANCE_VALUE) {
        return '#D96977';
      }

      return '#EECE70';
    },
  },
  mounted() {},
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@500&display=swap');

.marker-responsive {
  font-size: 0.575rem;
}
.marker {
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  line-height: 1rem;
  letter-spacing: 0.25%;
  color: #434343;
}
.marker-desktop {
  font-size: 0.625rem;
}
.main-primary {
  background-color: #b8c9d9;
}
.accent-secondary {
  background-color: #0c90cf;
}
.main-primary-20 {
  background-color: #cfdae6;
}
.main-primary-10 {
  background-color: #d9d9d9;
}
.divider {
  width: 1rem;
  border: solid 1px #d9d9d9;
  transform: rotate(-90deg);
  background-color: #d9d9d9;
}
</style>
